module.exports = __webpack_public_path__ + "img/bird-4.71c72934.png";